/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

interface AcceptLinkInvitationMutationProps {
    channel: object;
    eraseInvitation?: boolean;
    invitationId?: string;
}

export default class AcceptLinkInvitationMutation extends Relay.Mutation<AcceptLinkInvitationMutationProps> {
    static propTypes = {
        channel: PropTypes.object.isRequired,
        eraseInvitation: PropTypes.bool,
        invitationId: PropTypes.string,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Channel {
                    organisation_id,
                    realId,
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {acceptLinkInvitation}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on AcceptLinkInvitationPayload {
                success,
                extraArgs,
                error,
                channel {
                    id,
                    realId,
                    organisation_id,
                    name,
                    agentLink,
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }

    getVariables() {
        return {
            invitation_id: this.props.invitationId,
            eraseInvitation: this.props.eraseInvitation,
            organisation_id: this.props.channel.organisation_id,
            channel_id: this.props.channel.realId,
        };
    }
}
